const PrecertificationReview = () => <h4>REVIEW</h4>;
export default PrecertificationReview;
